import { Inject, Injectable } from "@angular/core";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { IModalService, modalServiceInjectionToken } from "@zaeper/angular-dashboard-view-lib";
import { IAppSettingsModalForm, IAppSettingsModalService } from "./i-app-settings-modal.service";
import { AppSettingsModalComponent } from "./app-settings-modal.component";

@Injectable()
export class AppSettingsModalService implements IAppSettingsModalService {
  constructor(@Inject(modalServiceInjectionToken) private readonly _modalService: IModalService) {
  }

  public openAppSettingsModal(form: IAppSettingsModalForm): void {
    const dynamicDialogRef: DynamicDialogRef = this._modalService.open(AppSettingsModalComponent, {
      data: {
        app: form.app,
        receiver: form.receiver,
        onSaveCallback: () => {
          form.onSaveCallback?.();
          dynamicDialogRef.close();
        }
      },
      styleClass: "bg-white rounded-lg",
      header: `${form.app.name} konfigurieren`,
      showHeader: true,
      closable: true,
      width: "900px",
      closeOnEscape: true,
      dismissableMask: true
    });
  }
}
